export default __webpack_public_path__ + "static/media/futura-global-traits.709250e8.svg";